import React, { useEffect, useMemo, useState } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../../../components/buttons/BtnCancelar";
import apiRoutes from "../../../../../api/apiRoutes";
import { appFetchJson } from "../../../../../utils/http";

export default function EditarDepartamento({ initial, onClose = () => {}, onSaved = () => {} }) {
  const id = useMemo(() => initial?.id ?? null, [initial]);
  const [nombre, setNombre] = useState(initial?.nombre || "");
  const [codigo, setCodigo] = useState(initial?.codigo || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const isValid = nombre.trim() !== "" && codigo.trim() !== "";
  const changed = useMemo(() => {
    return nombre !== (initial?.nombre || "") || codigo !== (initial?.codigo || "");
  }, [nombre, codigo, initial]);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSave = async () => {
    if (!id || !changed || !isValid || saving) return;
    setSaving(true);
    setError("");
    try {
      const payload = { nombre: nombre.trim(), codigo: codigo.trim() };
      const updated = await appFetchJson(apiRoutes.departamentos.update(id), {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error actualizando departamento:", e);
      setError(e?.message || "Error al actualizar el departamento.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Departamento</h2>
          <button className="modal-close-x" onClick={onClose}><FaTimes /></button>
        </div>
        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">Modifique los datos del departamento</p>
          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}
          <div className="space-y-4">
            <div>
              <label className="form-label">Nombre *</label>
              <input
                type="text"
                className="input"
                value={nombre}
                onChange={e => setNombre(e.target.value)}
                placeholder="Nombre del departamento"
              />
            </div>
            <div>
              <label className="form-label">Código *</label>
              <input
                type="text"
                className="input"
                value={codigo}
                onChange={e => setCodigo(e.target.value)}
                placeholder="Código del departamento"
              />
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar label="Guardar" isValid={isValid && changed} saving={saving} onClick={handleSave} />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}